import {
  CourseFindById,
  courseCategoryList,
  terminalList,
  priorityList,
  courseSetBasicInformation,
  CourseTerminalListByCourse,
} from './Request';

const mapCourse = course => ({
  id: course.id,
  name: course.name,
  category: course?.CourseCategory?.id ?? '',
  description: course?.description ?? '',
  trainingHours: course?.trainingHours ?? 0,
  priority: course?.Priority?.id ?? '',
  expirationTime: course?.expirationTime ?? '',
  expirationDate: course?.expirationDate ?? null,
  thumbnail: course?.thumbnail ?? '',
});

export const fetchCourse = async ({ id = '' }) => {
  const courseObject = await CourseFindById({
    id,
  });

  const mappedObject = mapCourse(courseObject);

  const courseTerminals = await CourseTerminalListByCourse({
    courseId: mappedObject.id,
  });

  const mappedTerminals = courseTerminals.map(terminal => ({
    courseTerminalId: terminal.id,
    id: terminal.terminalId,
    name: terminal.Terminal.name,
  }));

  return { ...mappedObject, terminals: mappedTerminals };
};

export const fetchOptionsInformation = async () => {
  const promises = [];
  promises.push(courseCategoryList());
  promises.push(terminalList());
  promises.push(priorityList());

  const data = await Promise.all(promises);
  const categories = data[0];
  const terminals = data[1];
  const priorities = data[2];
  const expirationTime = data[3];

  return { categories, terminals, priorities, expirationTime };
};

export const setCourseBasicInformation = async courseData => courseSetBasicInformation(courseData);

export default {
  fetchCourse,
  fetchOptionsInformation,
  setCourseBasicInformation,
};
